import React from 'react'
import type { VirtuosoHandle } from 'react-virtuoso'

import type { ChannelItem } from '@/widgets/chat/model'

export type MessageScrollerContextValue = {
    virtuoso?: VirtuosoHandle
    items?: { data: ChannelItem; index: number }[]
}

export const MessageScrollerContext = React.createContext<React.MutableRefObject<MessageScrollerContextValue> | null>(
    null
)

export function useMessageScroller(): MessageScrollerContextValue {
    const scroller = React.useContext(MessageScrollerContext)
    if (!scroller) {
        throw new Error('Missing MessageScrollerContext')
    }
    return scroller.current
}
